import styled from "styled-components";

const Button = styled.button`
  width: 100%;
  padding: 12px 0;
  background: #2575e8;
  border-radius: 5px;
  font-size: 14px;
  border: none;
  cursor: pointer;
  color: white;
  text-transform: uppercase;
  margin-top:8px;
  font-weight: 600;
  letter-spacing: 1.0px;
  :disabled {
    opacity: 0.4;
  }
`

export default Button